exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Cabin+Condensed:400,500,600,700&display=swap);", ""]);

// module
exports.push([module.id, "*{-webkit-box-sizing:border-box;box-sizing:border-box}\nhtml{background-color:#eceff1;font-family:\"Cabin Condensed\",Helvetica,Arial,sans-serif}\nhtml,body{margin:0;border:0;padding:0}\nimg{max-width:100%;image-orientation:from-image}\na{color:#000;text-decoration:none}\na:visited{color:#000}\nul{list-style:none;margin:0px;padding:0px}", ""]);

// exports
